import sessionsSaga from "./sessions.saga";
import scheduleSaga from "./schedule.saga";
import suspendSaga from "./suspend.saga";
import reviewSaga from "./review.saga";
import openSessionSaga from "./openSession.saga";
import upcomingSessionSaga from "./upcomingSession.saga";

export default [
  sessionsSaga(),
  scheduleSaga(),
  suspendSaga(),
  reviewSaga(),
  openSessionSaga(),
  upcomingSessionSaga(),
];
